import styled from 'styled-components'
import IconButton from './IconButton'

export default styled(IconButton).attrs({
  type: 'circle-plus',
  color: props => props.theme.colors.green,
})``
